package com.karyadina.ui.screens.cloudsync

import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf

/**
 * Provides a platform-specific CloudSync settings UI component to the common UI module.
 * 
 * Used by SettingsDialog to display CloudSync settings without needing to depend on
 * platform-specific modules (like androidCloudSyncModule), thereby respecting the 
 * architecture pattern defined in CLOUDSYNC_VS_IAP_ARCHITECTURE.md.
 */
val LocalCloudSyncSettingsProvider = compositionLocalOf<@Composable () -> Unit> {
    {
        // By default, provide an empty composable.
        // Platforms (Android, Web) that implement CloudSync will override this
        // in their respective entry points (e.g., MainActivity.kt or main.js.kt).
    }
}
